"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CustomLink = _interopRequireDefault(require("./CustomLink.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _MobileLink = function MobileLink(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var item = props.item,
    isBullet = props.isBullet;
  var Icon = item.icon;
  if (item.children) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      href: item.url,
      className: (0, _classnames["default"])(_style["default"].mobileLink, open && _style["default"].open),
      onClick: function onClick() {
        return setOpen(!open);
      }
    }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), item.label, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].childrenIcon
    }, item.children && /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
      spaceLeft: true
    }))), open && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].children
    }, item.children.map(function (child) {
      return /*#__PURE__*/_react["default"].createElement(_MobileLink, {
        key: child.url,
        item: child,
        isBullet: true
      });
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_CustomLink["default"], _extends({
    to: item.url,
    className: _style["default"].mobileLink
  }, item.action ? {
    onClick: function onClick(e) {
      e.preventDefault();
      item.action();
    }
  } : {}), isBullet && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].bullet
  }, "\u2022"), Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), item.label);
};
_MobileLink.propTypes = {
  item: _propTypes["default"].object,
  isBullet: _propTypes["default"].bool
};
_MobileLink.defaultProps = {};
var _default = exports["default"] = _MobileLink;